import  htmlspecialchars_decode from "locutus/php/strings/htmlspecialchars_decode"

export default {
    replaceSizePhoto(link, width, height) {
        let replacedWidth = link.replace('photos/org', 'photos/' + width);
        return replacedWidth.replace('org', height).replace("http://plimg.redbay.pl", "https://plimg.redbay.pl");
    },

    decode(text) {
        return htmlspecialchars_decode(htmlspecialchars_decode(text));
    }
}



// WEBPACK FOOTER //
// ./src/components/cms/src/Cms.js